import {Component, EventEmitter, forwardRef, Input, NgZone, Output, ViewChild} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {InputChangeEventDetail, IonInput, IonTextarea} from '@ionic/angular';
import {AbstractNgModelComponent} from '../ng-model.component';

// @TODO pass input model type via component call

@Component({template: ''})
// @ts-ignore
export abstract class IonTextareaBaseComponent extends AbstractNgModelComponent<string> implements IonTextarea {

  @ViewChild('ionTextarea', {static: false}) ionTextareaElement;

  @Input() disabled: boolean;
  @Input() autoGrow: boolean = true;
  @Input() placeholder?: string;
  @Input() required?: boolean = false;
  @Input() autocapitalize: string;
  @Input() autofocus: boolean;
  @Input() clearOnEdit: boolean;
  @Input() spellcheck: boolean;
  @Input() debounce: number;
  @Input() cols: number;
  @Input() rows: number = 1;
  @Input() wrap: 'hard' | 'off' | 'soft' | undefined;
  @Input() enterkeyhint: 'enter' | 'done' | 'go' | 'next' | 'previous' | 'search' | 'send';

  @Input() inputmode: 'none' | 'text' | 'tel' | 'url' | 'email' | 'numeric' | 'decimal' | 'search' = 'none';
  @Input() max: string | number;
  @Input() min: string | number;
  @Input() minlength: number;
  @Input() maxlength?: number;
  @Input() name: string;
  @Input() readonly: boolean;
  @Input() fireFocusEvents: boolean;

  @Input() color: any;
  @Input() mode: 'ios' | 'md' = 'md';

  @Output() keyupEvent: EventEmitter<KeyboardEvent> = new EventEmitter();
  @Output() clickEvent: EventEmitter<MouseEvent> = new EventEmitter();

  @Output() ionBlur: EventEmitter<CustomEvent<FocusEvent>> = new EventEmitter();
  @Output() ionChange: EventEmitter<CustomEvent<InputChangeEventDetail>> = new EventEmitter();
  @Output() ionFocus: EventEmitter<CustomEvent<FocusEvent>> = new EventEmitter();
  @Output() ionInput: EventEmitter<CustomEvent<InputEvent>> = new EventEmitter();

  protected el: HTMLElement;
  protected z: NgZone;

  onBlur(event: CustomEvent<FocusEvent> | any) {
    if (this.fireFocusEvents) {
      this.ionBlur.emit(event);
    }

    this.onTouchModel(event);
  }

  onFocus(event: CustomEvent<FocusEvent> | any) {
    if (this.fireFocusEvents) {
      this.ionFocus.emit(event);
    }
  }

  onInput(event: CustomEvent<InputEvent> | any) {
    this.ionInput.emit(event);
  }

  onChange(event: CustomEvent<InputChangeEventDetail> | any) {
    // this.ionChange.emit(event);
  }

  onKeyup(event: KeyboardEvent) {
    this.keyupEvent.emit(event);
  }

  onClick(event: MouseEvent) {
    this.clickEvent.emit(event);
  }

  getInputElement(): Promise<HTMLTextAreaElement> {
    return this.ionTextareaElement.getInputElement();
  }

  setBlur(): Promise<void> {
    return this.ionTextareaElement.setBlur();
  }

  setFocus(): Promise<void> {
    return this.ionTextareaElement.setFocus();
  }

}
